import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import { displayFormattedDate, isEmpty } from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import {
  EditOutlined,
  EyeOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import PrintPdfModal from "../../common/PrintPdfModal";

function BillwisePaymentTable() {
  const columns = [
    {
      title: "Payment Number",
      dataIndex: "id",
      width: "100px",
    },
    {
      title: "Creditor",
      dataIndex: "creditor",
    },
    {
      title: "Voucher Date",
      dataIndex: "voucherDate",
      render: (text) => displayFormattedDate(text)
    },
    {
      title: "Voucher Type",
      dataIndex: "type",
    },
    {
      title: "Final Amount",
      dataIndex: "finalAmount",
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined />
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined />
          </Button>
          <Button
            size="small"
            onClick={() => handlePrint(record)}
          >
            <PrinterOutlined />
          </Button>
        </Space>
      ),
    },
  ];
  const [responseData, getRequest] = useApi(
    "/billwisePayment",
    null,
    API_METHODS.GET
  );
  const [tableData, setTableData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [visiblePrint, setVisiblePrint] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/billwisePayment?pageNumber=${1}`);
  }, []);// eslint-disable-line

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);// eslint-disable-line

  const editRecord = (record, isViewOnly = false) => {
    if (isViewOnly) {
      navigate("/portal/billwisePayment/view", {
        state: { payment_id: record.id, isViewOnly: isViewOnly },
      });
    } else {
      navigate("/portal/billwisePayment/edit", {
        state: { payment_id: record.id, isViewOnly: isViewOnly },
      });
    }
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };
  const onBillwisePaymentSearch = (id) => {
    if (!isEmpty(id))
      navigate("/portal/billwisePayment/view", {
        state: { payment_id: id, isViewOnly: false },
      });
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/billwisePayment?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  const handlePrint = (record) => {
    const flag = visiblePrint ? false : true;
    record && setSelectedRecord(record);
    setVisiblePrint(flag);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Billwise Payment</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="Billwise Payment Number"
              allowClear
              enterButton="Search"
              onSearch={onBillwisePaymentSearch}
            />
            <Button>
              <Link to="add">Add Billwise Payment</Link>
            </Button>
            <Button
              type="primary"
              onClick={handlePrint}
              disabled={selectedRows.length === 0}
            >
              Print Selected Billwise Payments
            </Button>
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        rowSelection={rowSelection}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visiblePrint && (
        <PrintPdfModal
          visible={visiblePrint}
          data={selectedRows.length !== 0 ? selectedRows : [selectedRecord]}
          title={"Payment Voucher"}
          close={handlePrint}
          pdfType="paymentVoucher"
        />
      )}
    </>
  );
}

export default BillwisePaymentTable;
